import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CreditCard, Loader2, CalendarClock } from "lucide-react";
import { toast } from "sonner";

export const PayButtons = ({ kind, refId, label, testId }) => {
  const [cfg, setCfg] = useState({});
  const [busy, setBusy] = useState("");

  useEffect(() => {
    api.get("/payments/config").then((r) => setCfg(r.data)).catch(() => {});
  }, []);

  const pay = async (provider) => {
    setBusy(provider);
    try {
      const { data } = await api.post(`/payments/${provider}/checkout`, { kind, ref_id: refId });
      if (data.checkout_url) { window.location.assign(data.checkout_url); return; }
      toast.error("تعذّر فتح صفحة الدفع");
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setBusy("");
  };

  return (
    <div className="space-y-2" data-testid={`pay-options-${kind}`}>
      <Button onClick={() => pay("moyasar")} disabled={!!busy}
        className="w-full rounded-xl h-11 gap-2 bg-accent hover:bg-accent/90" data-testid={testId}>
        {busy === "moyasar" ? <Loader2 className="w-4 h-4 animate-spin" /> : <CreditCard className="w-4 h-4" />} {label}
      </Button>
      <p className="text-xs text-muted-foreground text-center" data-testid={`pay-methods-${kind}`}>
        مدى • فيزا • ماستركارد • Apple Pay • STC Pay — دفع آمن عبر مُيسّر
      </p>
      {cfg.tamara_enabled && (
        <Button variant="outline" onClick={() => pay("tamara")} disabled={!!busy}
          className="w-full rounded-xl h-11 gap-2" data-testid={`pay-tamara-${kind}-btn`}>
          {busy === "tamara" ? <Loader2 className="w-4 h-4 animate-spin" /> : <CalendarClock className="w-4 h-4" />} قسّطها مع تمارا
        </Button>
      )}
    </div>
  );
};
